module.exports = __webpack_public_path__ + "img/header-weddingRingsBudgetMedium@2x.49d841a.jpg";